/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useFeatureFlag } from '@/features/globalConfig';
import { useLabels } from '@/hooks/useLabels';
import cx from 'classnames';
import { Button, View } from '@az/starc-ui';
import { sessionStorage } from '@/utils/sessionStorage';
import styles from './styles.module.scss';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { usePreferredVehicle } from '@/features/header/hooks/usePreferredVehicle';
import { useMyProfile } from '@/features/myProfile/api/getMyProfile';
import { SubmitReviewButton } from '../SubmitReviewButton/SubmitReviewButton';

const labelMap = {
  writeAReview: 'label_reviews_writeAReview',
  goToProduct: 'label_reviews_goToProduct',
};

export const ReviewCTAButtons = ({ pdpURL, className }: { pdpURL: string; className?: string }) => {
  const preferredVehicle = usePreferredVehicle();
  const { data: myProfile } = useMyProfile();
  const labels = useLabels(labelMap);

  const bvAPIEnabled = useFeatureFlag('BV_API_ENABLED') === 'true';

  const { data: productData } = useProductDetails({ enabled: false });

  const onGoToProduct = () => {
    sessionStorage.setItem('productFindingMethod', 'Reviews');
  };

  return (
    <View className={cx(className)} attributes={{ 'data-testid': 'cta' }}>
      {bvAPIEnabled && (
        <View className={styles.reviewsCTAButton}>
          <SubmitReviewButton
            productId={productData?.product?.itemId}
            productImage={productData?.product?.itemImageUrl}
            productTitle={productData?.product?.itemDescription}
            label={labels.writeAReview}
            pageType="ProductReview"
            defaultValues={{
              useremail: myProfile?.email,
              usernickname: myProfile?.firstName,
              vehicle: preferredVehicle?.vehicleName,
            }}
          />
        </View>
      )}

      <View className={styles.reviewsCTAButton}>
        <Button href={pdpURL} onClick={onGoToProduct}>
          {labels.goToProduct}
        </Button>
      </View>
    </View>
  );
};
